import { apiGet } from '../../fetch/apiService';

export function fetchWidgets(dashboardUuid) {
	return apiGet(`dashboards/${dashboardUuid}`);
}

